export const template_0002 = `
<div class="all-floors-scroll-wrapper no-scrollbar" style="width:100%;overflow-x:auto;box-sizing:border-box;">
    <style>
        .no-scrollbar {
            overflow: auto;
            scrollbar-width: none;
            /* Firefox */
            -ms-overflow-style: none;
            /* IE 10+ */
        }

        /* Ẩn scrollbar trên Chrome, Safari */
        .no-scrollbar::-webkit-scrollbar {
            display: none;
            width: 0px;
            height: 0px;
        }

        .left-part {
            width: 30vw;
            height: 100%;
            display: block;
            opacity: 0;
        }

        .right-part {
            width: 50vw;
            height: 100%;
            display: block;
            opacity: 0;
        }

        .no-border-bottom {
            border-bottom: none !important;
        }

        .floor-guide-floor--bg-white {
            background-color: var(--color-bg-white) !important;
        }
        .font-small {
            font-size: 1.3vh;
        }
    </style>
    <div class="all-floors-inner floor-guide-drag-container"
        style="width:104.3333333334vw;display:flex;box-sizing:border-box;">
        <div class="left-part">1</div>
        <div class="floor-guide-floors" id="worldtower">
            <div class="floor-guide-mall-name">
                <div class="floor-guide-mall-name-tts">월드타워</div>
            </div>
            <div class="floor-guide-floor floor-guide-no-click" data-id="FL-1jiaijaxohovr4327" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english font-small">117F<br/>-123F</span>
                <span class="floor-guide-floor-desc">SEOUL SKY (전망대)</span>
            </div>
            <div class="floor-guide-floor floor-guide-no-click" data-id="FL-1jiaijaxohovr4327" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english font-small">76F<br/>-101F</span>
                <span class="floor-guide-floor-desc">시그니엘 서울</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-1jiaijaxohovr4327" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english">31F</span>
                <span class="floor-guide-floor-desc">SKY31 컨벤션ㅣ마키노차야블랙31</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-1jiaijaxohovr4327" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english">30F</span>
                <span class="floor-guide-floor-desc">워크플렉스 롯데월드타워</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray no-border-bottom" data-id="FL-1hrj94p1zs2m14355" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
            <div class="floor-guide-floor" data-id="FL-1jiaijaxohovr4327" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english">12F</span>
                <span class="floor-guide-floor-desc">은행ㅣ증권</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-sl15eempzdr84340" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english">11F</span>
                <span class="floor-guide-floor-desc">안과ㅣ치과ㅣ피부과ㅣ카페</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray no-border-bottom" data-id="FL-1hrj94p1zs2m14355" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray no-border-bottom" data-id="FL-rl042p1d1v7b4376" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray no-border-bottom" data-id="FL-vbmxfa3a2a7l4402" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray no-border-bottom" data-id="FL-rhiu9pjwtwkz4423" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right floor-guide-no-click" data-id="FL-t4vqscsfs7ci4441" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english">7F</span>
                <span class="floor-guide-floor-desc">뮤지엄</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray no-border-bottom" data-id="FL-t4nv4gumihcx4511" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray no-border-bottom" data-id="FL-t4nv4gumihcx4511" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray" data-id="FL-qdt9ayjtve494549" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray" data-id="FL-u7rsiy7lfjvq4591" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english">2F</span>
                <span class="floor-guide-floor-desc">로비</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-1hv2q23iykrhs4641" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english">1F</span>
                <span class="floor-guide-floor-desc">명품잡화ㅣ화장품ㅣ시계&amp;보석</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-ts56rc9vkjec4705" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english">B1</span>
                <span class="floor-guide-floor-desc">식품</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray" data-id="FL-qhqlf2653bdy4781" data-x="0" data-y="0">
                <span class="floor-guide-floor-name english">B2-B4</span>
                <span class="floor-guide-floor-desc">Parking Lot</span>
            </div>
        </div>
        <div class="floor-guide-floors" id="worldmall">
            <div class="floor-guide-mall-name">
                <div class="floor-guide-mall-name-tts">월드몰</div>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-t4vqscsfs7ci4441" data-x="13011" data-y="4552">
                <span class="floor-guide-floor-name english">6F</span>
                <span class="floor-guide-floor-desc">식당가ㅣ뷰티&amp;스파ㅣ시네마</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-qxqkodqsjub84475" data-x="13011" data-y="4552">
                <span class="floor-guide-floor-name english">5F</span>
                <span class="floor-guide-floor-desc">식당가ㅣ카페ㅣ롯데시네마</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-t4nv4gumihcx4511" data-x="13011" data-y="4552">
                <span class="floor-guide-floor-name english">4F</span>
                <span class="floor-guide-floor-desc">키즈ㅣ서점ㅣ캐주얼ㅣ씨푸드 레스토랑</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-qdt9ayjtve494549" data-x="13011" data-y="4552">
                <span class="floor-guide-floor-name english">3F</span>
                <span class="floor-guide-floor-desc">스포츠·레저ㅣ패밀리레스토랑ㅣ하이마트</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-u7rsiy7lfjvq4591" data-x="13011" data-y="4552">
                <span class="floor-guide-floor-name english">2F</span>
                <span class="floor-guide-floor-desc">SPAㅣ여성패션ㅣ카페ㅣ악세사리</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-1hv2q23iykrhs4641" data-x="13011" data-y="4552">
                <span class="floor-guide-floor-name english">1F</span>
                <span class="floor-guide-floor-desc">SPAㅣ화장품ㅣ여성패션ㅣ베이커리·카페</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--has-right" data-id="FL-ts56rc9vkjec4705" data-x="13011" data-y="4552">
                <span class="floor-guide-floor-name english">B1</span>
                <span class="floor-guide-floor-desc">패션ㅣ푸드코트ㅣ아쿠아리움</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--transparent" data-id="" data-x="0" data-y="0">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
        </div>
        <div class="floor-guide-floors" id="avenuel">
            <div class="floor-guide-mall-name">
                <div class="floor-guide-mall-name-tts">에비뉴엘</div>
            </div>
            <div class="floor-guide-floor" data-id="FL-rl042p1d1v7b4376" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english">9F</span>
                <span class="floor-guide-floor-desc">홈패션ㅣ주방식기ㅣ가구</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-vbmxfa3a2a7l4402" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english">8F</span>
                <span class="floor-guide-floor-desc">아동ㆍ유아ㅣ사은품증정</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--gray" data-id="FL-rhiu9pjwtwkz4423" data-x="5979" data-y="4463">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
            <div class="floor-guide-floor" data-id="FL-t4vqscsfs7ci4441" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">6F</span>
                <span class="floor-guide-floor-desc">프리미엄 F&amp;B ㅣ와인</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-qxqkodqsjub84475" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">5F</span>
                <span class="floor-guide-floor-desc">여성 컨템포러리</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-t4nv4gumihcx4511" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">4F</span>
                <span class="floor-guide-floor-desc">럭셔리 맨즈</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-qdt9ayjtve494549" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">3F</span>
                <span class="floor-guide-floor-desc">럭셔리 디자이너</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-u7rsiy7lfjvq4591" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">2F</span>
                <span class="floor-guide-floor-desc">워치&amp;주얼리ㅣ럭셔리 디자이너</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-1hv2q23iykrhs4641" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">1F</span>
                <span class="floor-guide-floor-desc">럭셔리 부티크</span>
            </div>
            <div class="floor-guide-floor" data-id="FL-ts56rc9vkjec4705" data-x="10356" data-y="4637">
                <span class="floor-guide-floor-name english">B1</span>
                <span class="floor-guide-floor-desc">화장품</span>
            </div>
            <div class="floor-guide-floor floor-guide-floor--transparent" data-id="" data-x="0" data-y="0">
                <span class="floor-guide-floor-name english"></span>
                <span class="floor-guide-floor-desc"></span>
            </div>
        </div>
        <div class="right-part">2</div>
    </div>
</div>`;